var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _path16, _path17, _path18, _path19, _path20, _path21, _rect2, _polygon3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _polygon4, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrey2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66.74 104.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{stroke-width:0px;}.cls-1,.cls-19{fill:none;}.cls-2{fill:url(#linear-gradient);}.cls-19{stroke:#3c517a;stroke-miterlimit:10;}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-8);}.cls-7{fill:url(#linear-gradient-9);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:#fad0dc;}.cls-12{fill:#263d63;}.cls-13{fill:#3c517a;}.cls-14{fill:#121413;}.cls-15{fill:#173159;}.cls-16{fill:#bed0df;}.cls-17{fill:#fff;}.cls-18{fill:#e566a0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 48.09,
    y1: 7.9,
    x2: 47.82,
    y2: 15.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cf9c97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#dfb3aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ecc4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f5d0c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fad8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcdaca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3680.62,
    y1: 7.7,
    x2: 3680.36,
    y2: 15.58,
    gradientTransform: "translate(3701.97) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2739.9,
    y1: 2375.11,
    x2: 2747.36,
    y2: 2375.11,
    gradientTransform: "translate(2967.61 2102.88) rotate(-103.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf8786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cd9a95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ddb1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#eac2b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f3cec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f8d6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2745.11,
    y1: 2375.19,
    x2: 2746.88,
    y2: 2375.23,
    gradientTransform: "translate(2967.61 2102.88) rotate(-103.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf8786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c28b8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#d6a7a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#e6bdb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f1ccbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f7d5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad8c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1928.08,
    y1: -907.53,
    x2: 1935.54,
    y2: -907.53,
    gradientTransform: "translate(480.66 2102.88) rotate(-76.11)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1933.29,
    y1: -907.45,
    x2: 1935.06,
    y2: -907.41,
    gradientTransform: "translate(480.66 2102.88) rotate(-76.11)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 34.72,
    y1: 22.71,
    x2: 34.72,
    y2: 33.03,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 34.98,
    y1: 6.54,
    x2: 34.98,
    y2: 22.9,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -4463.27,
    y1: 2.9,
    x2: -4463.27,
    y2: 26.92,
    gradientTransform: "translate(-4429.69) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e393d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3f3b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#464245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#514e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#626061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#777"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.51,9.06l1.58-.88c.09-.05.2-.08.3-.08h.6c.16,0,.32.06.44.18l.21.21c.13.12.19.29.19.46l-.12,4.75c0,.14-.05.27-.14.38l-.77.96c-.17.21-.45.29-.7.2l-1.19-.42c-.23-.08-.4-.3-.41-.55l-.32-4.62c-.02-.24.11-.47.32-.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m22.89,9.04l-1.53-.85c-.1-.06-.22-.09-.34-.09h-.56c-.18,0-.35.07-.48.2l-.17.17c-.14.13-.21.32-.21.51l.11,4.7c0,.15.06.3.15.42l.73.91c.18.23.49.32.77.22l1.1-.39c.26-.09.44-.33.46-.6l.32-4.54c.02-.27-.12-.52-.35-.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m16.74,94.03l6.41-.23,1.09-17.07c.15-2.32-1.74-4.26-4.06-4.18h0c-2.15.08-3.84,1.86-3.79,4.01l.36,17.47Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m25.22,64.32l-7.75,9.29c-1.53,1.83-1.26,4.57.59,6.07h0c1.71,1.38,4.19,1.25,5.74-.32l8.55-8.64c1.78-1.8,1.62-4.74-.35-6.34l-.8-.64c-1.82-1.47-4.48-1.21-5.98.58Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m25.15,60.15h19.61v4.59c0,2.68-2.17,4.85-4.85,4.85h-9.9c-2.68,0-4.85-2.17-4.85-4.85v-4.59h0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5.82 12.03 5.5 10.73 5.97 9.93 5.51 6.71 5.18 5.38 3.77 5.72 3.87 6.33 2.76 6.49 1.81 6.71 .94 7.01 .99 7.2 .9 6.84 0 7 .09 7.73 0 8.41 .97 11.29 1.93 11.85 2.35 13.76 6.02 12.86 5.82 12.03"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m4.85,7.15l-1.1-.11s-.02,0-.03.01l-.59.51s-.04.01-.06,0l-.34-.25s-.03-.01-.05,0l-.38.16-.38.16s-.01,0-.02,0l-.47-.02s-.02,0-.03.01l-.83.67.92-.54s.02,0,.03,0l.42.04s.02,0,.03,0l.31-.2s0,0,.01,0l.35-.11s.03,0,.04,0l.4.25s.04,0,.05,0l.62-.54s.02-.01.03-.01l1.08-.02Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m9.11,30.21h0c1.55-.57,2.35-2.29,1.78-3.84l-4.72-14.56-4.35,1.37,3.34,14.88c.4,1.76,2.26,2.77,3.95,2.15Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m5.38,26.17h0c.62-1.51,2.3-2.3,3.86-1.81l15.36,4.85c2.35.74,3.56,3.34,2.63,5.62h0c-.91,2.22-3.5,3.23-5.68,2.21l-14.59-6.82c-1.52-.71-2.22-2.5-1.58-4.05Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "60.91 12.03 61.23 10.73 60.77 9.93 61.23 6.71 61.56 5.38 62.96 5.72 62.87 6.33 63.98 6.49 64.92 6.71 65.8 7.01 65.75 7.2 65.84 6.84 66.74 7 66.65 7.73 66.73 8.41 65.77 11.29 64.81 11.85 64.38 13.76 60.71 12.86 60.91 12.03"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m61.89,7.15l1.1-.11s.02,0,.03.01l.59.51s.04.01.06,0l.34-.25s.03-.01.05,0l.38.16.38.16s.01,0,.02,0l.47-.02s.02,0,.03.01l.83.67-.92-.54s-.02,0-.03,0l-.42.04s-.02,0-.03,0l-.31-.2s0,0-.01,0l-.35-.11s-.03,0-.04,0l-.4.25s-.04,0-.05,0l-.62-.54s-.02-.01-.03-.01l-1.08-.02Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m57.62,30.21h0c-1.55-.57-2.35-2.29-1.78-3.84l4.72-14.56,4.35,1.37-3.34,14.88c-.4,1.76-2.26,2.77-3.95,2.15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m61.35,26.47h0c-.62-1.51-2.3-2.3-3.86-1.81l-15.36,4.85c-2.35.74-3.56,3.34-2.63,5.62h0c.91,2.22,3.5,3.23,5.68,2.21l14.59-6.82c1.52-.71,2.22-2.5,1.58-4.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m20.31,92.24c1.06-.04,1.94.81,1.95,1.87.01,1.46.04,3.41.13,4.64.14,1.97.17,4.91.17,4.91,0,0-10.23,1.24-12.42.99,0,0-.03-4.04,3.99-4.51,4.03-.47,4.8-.28,4.8-.28l-.44-5.58c-.08-1.07.74-2,1.81-2.03h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m22.54,100.15c-1.11.9-1.62,2.13-1.84,3.02-.07.26-.11.49-.14.68,1.24-.14,2.08-.24,2.08-.24,0,0,0-.22,0-.59-.01-.66-.04-1.77-.09-2.87Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m19.99,100.76l-.18-5-1.19.04.32,4.05s-.77-.19-4.8.28c-.38.04-.72.12-1.03.22l.82.92c2.49-1.3,6.06-.51,6.06-.51Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m20.67,103.22c-2.97.21-8.09.53-8.09.53-.1-1.37-.48-2.15-.88-2.59-1.53,1.35-1.52,3.48-1.52,3.48,1.57.18,7.24-.4,10.35-.75,1.24-.14,2.08-.24,2.08-.24,0,0,0-.22,0-.59-.29.03-1,.08-1.93.15Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 15.53,
    y: 91.99,
    width: 7.94,
    height: 3.38
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m53.32,93.58l-6.41-.23-1.09-17.07c-.15-2.32,1.74-4.26,4.06-4.18h0c2.15.08,3.84,1.86,3.79,4.01l-.36,17.47Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m44.85,63.88l7.75,9.29c1.53,1.83,1.26,4.57-.59,6.07h0c-1.71,1.38-4.19,1.25-5.74-.32l-8.55-8.64c-1.78-1.8-1.62-4.74.35-6.34l.8-.64c1.82-1.47,4.48-1.21,5.98.58Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m49.76,91.79c-1.06-.04-1.94.81-1.95,1.87-.01,1.46-.04,3.41-.13,4.64-.14,1.97-.17,4.91-.17,4.91,0,0,10.23,1.24,12.42.99,0,0,.03-4.04-3.99-4.51-4.03-.47-4.8-.28-4.8-.28l.44-5.58c.08-1.07-.74-2-1.81-2.03h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m47.53,99.7c1.11.9,1.62,2.13,1.84,3.02.07.26.11.49.14.68-1.24-.14-2.08-.24-2.08-.24,0,0,0-.22,0-.59.01-.66.04-1.77.09-2.87Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m50.08,100.32l.18-5,1.19.04-.32,4.05s.77-.19,4.8.28c.38.04.72.12,1.03.22l-.82.92c-2.49-1.3-6.06-.51-6.06-.51Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m49.4,102.77c2.97.21,8.09.53,8.09.53.1-1.37.48-2.15.88-2.59,1.53,1.35,1.52,3.48,1.52,3.48-1.57.18-7.24-.4-10.35-.75-1.24-.14-2.08-.24-2.08-.24,0,0,0-.22,0-.59.29.03,1,.08,1.93.15Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 46.6,
    y: 91.54,
    width: 7.94,
    height: 3.38,
    transform: "translate(101.13 186.47) rotate(-180)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "37.95 30.37 31.49 30.37 32.39 21.6 37.05 21.6 37.95 30.37"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m49.1,31.79c.12-1.14-.38-2.31-1.38-2.86-.32-.18-.69-.3-1.07-.35l-8.99-1.09s-.21,1.93-2.95,1.93-2.95-1.93-2.95-1.93l-8.99,1.09c-.38.05-.75.17-1.07.35-1,.56-1.5,1.73-1.37,2.87l3.5,32.19h21.91l3.34-32.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m34.98,4.08h-11.02c-.75,0-1.35.61-1.35,1.35v8.4c0,2.69,1.5,5.16,3.9,6.4l5.18,2.67c2.07,1.07,4.53,1.07,6.61,0l5.18-2.67c2.39-1.24,3.9-3.7,3.9-6.4V5.43c0-.75-.61-1.35-1.35-1.35h-11.02Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m25.62,28.19s3.96,11.52-3.22,22.51l.26,2.34s13.01-9.68,7.25-25.3c0,0-3.75.18-4.29.45Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m44.41,28.19s-4.46,11.58,2.72,22.57l-.24,2.29s-12.53-9.69-6.78-25.31c0,0,3.75.18,4.29.45Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m34.95,65.76c-1.57.03-1.57,1.94-1.57,1.94v.14s3.14,0,3.14,0l-.02-.2s.02-1.9-1.56-1.88Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m33.86,34.08h2.17c5.52,0,9.99,4.48,9.99,9.99v10.16c0,2.85-2.31,5.16-5.16,5.16h-11.85c-2.85,0-5.16-2.31-5.16-5.16v-10.16c0-5.52,4.48-9.99,9.99-9.99Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m26.89,49.25h17.01v6.63c0,.45-.37.82-.82.82h-15.38c-.45,0-.82-.37-.82-.82v-6.63h0Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "26.89 47.91 43.9 47.91 44.39 49.65 26.29 49.65 26.89 47.91"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m32.05,35.9s-.04-3.99,2.42-4.02,2.69,3.67,2.69,3.67l-5.11.35Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m48.33,23.56c-.08.41-.22.79-.6.95-1.94.83-7.2,3.09-12.72,3.01s-13.65-3-16.25-4c-.48-.18-.74-.69-.62-1.19.81-3.26,3.49-11.42,1.98-16.34-.02-.07-.03-.14-.03-.22v-.27c.04-1.29.89-2.41,2.12-2.8L29.94.24c1.29-.08,4.16-.16,5.45-.24l10.52,2.23c1.61.3,2.19,1.52,2.76,3.06,0,0,1.05,10.93-.33,18.27Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrey2);
export default __webpack_public_path__ + "static/media/grey_2.5adfeb9bdce88ed603730ec20947789b.svg";
export { ForwardRef as ReactComponent };